import React from "react";
import { NavLink } from "react-router-dom";
import Connection from "../../elements/connection/Connection";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { useTranslation } from "react-i18next";

import { StyledServiceGrid, StyledServiceLink } from "../styledServices";

const ServiceList = ({ userServices }) => {
  const { t } = useTranslation("servicePage");

  if (!userServices) {
    return <PageSpinner position="center" pt="20" pb="20" />;
  }

  if (userServices.length === 0) {
    return <Alert severity="warning">{t("list.emptyData")}</Alert>;
  }

  return (
    <StyledServiceGrid>
      {userServices && userServices.map((value, key) => (
        <StyledServiceLink as={NavLink} to={`/services/${value.service.id}`} key={key}>
          <Connection name={value.service.name} enable={value.service.enable} />
        </StyledServiceLink>
      ))}
    </StyledServiceGrid>
  );
};
export default ServiceList;